/**
 * Tenant API Module
 * Handles tenant-specific operations
 */

import axiosClient, { isNoAuthMode } from "./client";
import { FailedTenantsResponse } from "./types";
import { getSessionId, getAuthType } from "../security/authStorage";
import { createLogger } from "../utils/logging";

const logger = createLogger("Tenant API");

// ============================================================================
// Failed Tenants
// ============================================================================

/**
 * Get failed tenants (tenants user doesn't have access to)
 *
 * @param tenantId - The current tenant ID to include in the request header
 */
export async function getFailedTenants(tenantId: string): Promise<FailedTenantsResponse | null> {
  try {
    let response;

    if (isNoAuthMode()) {
      // No-auth (local dev): simple fetch, no auth headers needed
      response = await axiosClient.get<FailedTenantsResponse>("./tenant/failed");
    } else {
      // All deployed environments: use tenant/tenant/failed with explicit auth headers.
      // The auth proxy requires Session-ID, Auth-Type, and tenant-id to authorize the request.
      response = await axiosClient.get<FailedTenantsResponse>("./tenant/tenant/failed", {
        headers: {
          "Session-ID": getSessionId() as string,
          "Auth-Type": getAuthType() as string,
          "tenant-id": tenantId,
        },
      });
    }

    return response.data;
  } catch (error) {
    logger.warn("Fetch Failed", "Unable to retrieve failed tenants", { error });
    return null;
  }
}
